import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(ConfigurationExporterConfiguration);

    /** @ngInject */
    function ConfigurationExporterConfiguration($stateProvider) {
        $stateProvider.state(
            'company_employee.configuration.exporterconfiguration',
            {
                url: '/ustawienia-eksportu',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/company_configuration/exporter/exporter.html'),
                controller: 'CompanyConfigurationExporterController',
                controllerAs: 'CompanyConfigurationExporterCtrl',
            }
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/company_configuration/exporter/exporter.route.ts